export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_complete_4.a5169209.jpg";